<template>
  <div v-if="loadingPath">
    <div class="box p-5 text-center text-xl text-gray-600">
      โหลดสายอนุมัติ
    </div>
  </div>
  <div v-else>
    <div
      class="box p-5 text-center text-xl text-red-600"
      v-if="document.length === 0"
    >
      ไม่พบเส้นทางการอนุมัติ
    </div>
    <div
      v-else-if="flagEdit == 2"
      class="box p-5 text-center text-xl text-red-600"
    >
      เอกสารถูกตีกลับ
    </div>
    <div class="box p-5" v-else>
      <div
        class="wizard flex flex-col lg:flex-row justify-center px-5 sm:px-20"
      >
        <div
          class="intro-x lg:text-center flex items-center lg:block flex-1 z-10"
          v-for="(item, index) in documentNew"
          :key="item.status_code"
        >
          <button
            class="w-10 h-10 rounded-full btn "
            :class="item.bg_color_class"
          >
            {{ index + 1 }}
          </button>
          <div class="lg:w-32 lg:mt-3 ml-3 lg:mx-auto">
            {{ item.status_name }}
          </div>
        </div>
        <div
          class="wizard__line hidden lg:block w-4/5 lg:w-3/4 bg-gray-200 dark:bg-dark-1 absolute mt-5"
        ></div>
      </div>
      <div class="intro-y mt-5">
        <div
          class="py-5 lg:px-20 border-t border-gray-200"
          v-for="result in approve"
          :key="result.employee_id"
        >
          <div class="flex">
            <div class="w-10 h-10 sm:w-12 sm:h-12 flex-none image-fit">
              <img
                :alt="result.employee_name"
                class="rounded-full"
                :src="result.employee_image"
                @error="$h.imgError"
              />
            </div>
            <div class="ml-3 flex-1">
              <div class="flex items-center">
                <div class="font-medium">{{ result.employee_name }}</div>
                <div
                  class="font-medium ml-auto rounded px-2 py-1 text-white"
                  :class="bgStatusApprove(result.result)"
                >
                  <CheckCircleIcon
                    size="1x"
                    class="mr-2"
                    v-if="
                      result.result == 'approve' ||
                        result.result == 'edit_complete'
                    "
                  />
                  <XCircleIcon
                    size="1x"
                    class="mr-2"
                    v-if="result.result == 'disapprove'"
                  />
                  <AlertCircleIcon
                    size="1x"
                    class="mr-2"
                    v-if="
                      result.result == 'edit' || result.result == 'edit_all'
                    "
                  />
                  {{ result.result_text }}
                </div>
              </div>
              <div class="text-gray-600 text-xs sm:text-sm">
                {{ result.date }}
              </div>
              <div
                class="mt-2"
                v-html="
                  result.reason ? result.reason.replaceAll('\n', '<br />') : ''
                "
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed, watch, ref } from 'vue'
import { helper as $h } from '@/utils/helper'
export default defineComponent({
  props: {
    nextStatusCode: String,
    statusCode: String,
    documentPath: Array,
    approveResult: Array,
    flagEdit: {
      type: Number,
      default: () => 0
    }
  },
  setup(props) {
    const document = computed(() => [...props.documentPath])
    const approve = computed(() => [...props.approveResult])
    const status = computed(() => props.statusCode)
    const nextStatus = computed(() => props.nextStatusCode)
    const loadingPath = ref(true)

    const documentNew = computed(() => {
      const path = [...props.documentPath]
      let isPass = true
      const statusType = status.value.substr(3)
      // console.log('status:', status.value, statusType)
      return path.map(item => {
        if (item.status_code == status.value) {
          if (nextStatus.value == status.value) {
            item.bg_color_class = 'btn-primary'
          } else {
            item.bg_color_class = 'btn-outline-primary bg-gray-200'
          }
          isPass = false
        } else if (statusType == 'DRAFT' && isPass) {
          item.bg_color_class = 'btn-primary'
          isPass = false
        } else {
          if (isPass) {
            item.bg_color_class = 'btn-primary'
          } else {
            item.bg_color_class = 'bg-gray-200'
          }
        }
        return item
      })
    })

    if (document.value.length > 0) {
      loadingPath.value = false
    }
    const bgStatusApprove = result => {
      if (result === 'approve' || result == 'edit_complete') {
        return 'bg-theme-9'
      } else if (result == 'disapprove') {
        return 'bg-theme-6'
      } else if (result == 'edit' || result == 'edit_all') {
        return 'bg-theme-12'
      } else {
        return 'bg-theme-13'
      }
    }

    watch(document, () => {
      loadingPath.value = false
    })
    return {
      props,
      status,
      nextStatus,
      approve,
      document,
      loadingPath,
      documentNew,
      bgStatusApprove,
      $h
    }
  }
})
</script>
